import React, { useState, useEffect, useCallback, useMemo } from "react";
import styled from "styled-components";
import SideNavAccount from "../../components/SideNav/SideNavAccount";
import { BsCalendar3 } from "react-icons/bs";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { AiOutlinePlus, AiOutlineHeart, AiFillHeart } from "react-icons/ai";
import { useMealMate } from "../../context/MealMateContext";
import { useNavigate, useLocation, Link } from "react-router-dom";
import AddRecipeModal from "./AddRecipeModal";
import api from "../../api";
import { App, DatePicker } from "antd";
import dayjs from "dayjs";

// ======================= Styled Components =======================
const DailyMenuPageWrapper = styled.div`
  display: flex;
`;

const MainContent = styled.div`
  flex: 1;
  padding: 2rem;
  background-color: #f9f9f9;
  min-height: 100vh;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`;

const DateNavigation = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  h2 {
    font-size: 1.8rem;
    color: #333;
  }
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const ArrowButton = styled.button`
  background: none;
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
  color: #555;
  &:hover {
    color: #ff4b4b;
  }
`;

const CalendarButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #555;
  &:hover {
    color: #ff4b4b;
  }
`;

const FavoritesButton = styled.button`
  background: linear-gradient(135deg, #ff6b6b, #ff4b4b);
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 25px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(255, 75, 75, 0.3);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 75, 75, 0.4);
    background: linear-gradient(135deg, #ff5252, #ff3333);
  }

  &:active {
    transform: translateY(0px);
  }

  .heart-icon {
    font-size: 1.2rem;
    animation: heartbeat 2s infinite;
  }

  @keyframes heartbeat {
    0%,
    50%,
    100% {
      transform: scale(1);
    }
    25%,
    75% {
      transform: scale(1.1);
    }
  }
`;

const NutritionSummary = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
  background: white;
  padding: 1.5rem;
  border-radius: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
`;

const NutritionItem = styled.div`
  h4 {
    margin-bottom: 0.5rem;
    color: #555;
    font-size: 1rem;
  }

  p {
    font-size: 0.9rem;
    color: #777;
  }
`;

const ProgressBar = styled.div`
  height: 6px;
  background: #f0f0f0;
  border-radius: 3px;
  margin-bottom: 0.5rem;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: ${(props) => props.progress}%;
    background: #ff4b4b;
    border-radius: 3px;
    transition: width 0.3s ease;
  }
`;

const MealsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const MealSection = styled.div`
  background: white;
  padding: 1.5rem;
  border-radius: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
`;

const MealHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;

  h2 {
    font-size: 1.5rem;
    color: #333;
  }
`;

const AddButton = styled.button`
  background: #ff4b4b;
  color: white;
  border: none;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  &:hover {
    opacity: 0.9;
  }
`;

const MealCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f7f7f7;
  padding: 1rem;
  border-radius: 10px;
  margin-bottom: 0.8rem;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.03);
`;

const MealInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  img {
    width: 60px;
    height: 60px;
    border-radius: 10px;
    object-fit: cover;
  }

  h3 {
    font-size: 1.1rem;
    margin-bottom: 0.2rem;
    color: #333;
  }

  span {
    color: #999;
    font-size: 0.9rem;
  }
`;

const MealActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const FavoriteMenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  color: #555; /* Màu mặc định */

  &:hover {
    color: #ff4d4f; /* Màu đỏ khi hover */
  }
`;
const ActionButton = styled.button`
  background: none;
  border: none;
  color: ${(props) => props.color || "#ff4b4b"};
  font-size: ${(props) => props.size || "1.2rem"};
  cursor: pointer;
  padding: 0.3rem;
  border-radius: 4px;
  transition: all 0.2s ease;
  opacity: ${(props) => (props.loading ? 0.5 : 1)};
  pointer-events: ${(props) => (props.loading ? "none" : "auto")};

  &:hover {
    background: ${(props) => props.hoverBg || "rgba(255, 75, 75, 0.1)"};
    transform: scale(1.1);
  }
`;

const CalendarWrapper = styled.div`
  .ant-picker {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
    padding: 0;
    margin: 0;
    pointer-events: none;
  }
`;

// ======================= Component logic =======================
const DailyMenuPage = () => {
  const { message: antdMessage } = App.useApp();
  const { state } = useLocation();
  const [isCalendarVisible, setIsCalendarVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(() => {
    if (state?.selectedDate) {
      return new Date(state.selectedDate);
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  });
  const [dailyMenu, setDailyMenu] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentMealType, setCurrentMealType] = useState("");
  const [actionLoading, setActionLoading] = useState({}); // Giữ lại actionLoading cho Remove Meal
  const { user, setShowLoginModal } = useMealMate(); // Loại bỏ triggerFavoriteRecipesRefresh
  const navigate = useNavigate();

  // Wrap mealTypeMapping in useMemo
  const mealTypeMapping = useMemo(
    () => ({
      breakfast: "sáng",
      lunch: "trưa",
      dinner: "tối",
      snack: "ăn vặt",
    }),
    []
  ); // Empty dependency array since this mapping never changes

  const [nutritionData, setNutritionData] = useState({
    calories: { current: 0, target: user?.calorieGoal || 2000, unit: "kcal" },
    carbs: { current: 0, target: user?.carbohydrateGoal || 50, unit: "g" },
    protein: { current: 0, target: user?.proteinGoal || 100, unit: "g" },
    fat: { current: 0, target: user?.fatGoal || 70, unit: "g" },
  });

  useEffect(() => {
    if (!user) {
      navigate("/");
    }
  }, [user, navigate]);

  // THÊM: Hàm tính tổng calo cho một bữa ăn cụ thể
  const calculateMealCalories = useCallback(
    (mealType) => {
      const meals = dailyMenu?.meals?.[mealType] || [];
      return meals.reduce((total, meal) => {
        if (meal.recipe && typeof meal.recipe.calories === "number") {
          return total + meal.recipe.calories * meal.quantity;
        }
        return total;
      }, 0);
    },
    [dailyMenu]
  );

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    if (!user) {
      setLoading(false);
      return;
    }
    try {
      const formattedDate = selectedDate.toISOString().split("T")[0];

      const response = await api.get(`/daily/byDate?date=${formattedDate}`);

      if (response.data.dailyMenu) {
        const safeDailyMenu = {
          ...response.data.dailyMenu,
          meals: response.data.dailyMenu.meals || {
            breakfast: [],
            lunch: [],
            dinner: [],
            snack: [],
          },
        };
        setDailyMenu(safeDailyMenu);
        setNutritionData((prev) => ({
          calories: {
            ...prev.calories,
            current: safeDailyMenu.totalCalories || 0,
          },
          protein: {
            ...prev.protein,
            current: safeDailyMenu.totalProtein || 0,
          },
          carbs: {
            ...prev.carbs,
            current: safeDailyMenu.totalCarbs || 0,
          },
          fat: { ...prev.fat, current: safeDailyMenu.totalFat || 0 },
        }));
      } else {
        setDailyMenu(null);
        setNutritionData((prev) => ({
          calories: { ...prev.calories, current: 0 },
          protein: { ...prev.protein, current: 0 },
          carbs: { ...prev.carbs, current: 0 },
          fat: { ...prev.fat, current: 0 },
        }));
      }
    } catch (err) {
      setError("Không thể tải thực đơn ngày này. Vui lòng thử lại.");
      antdMessage.error("Không thể tải thực đơn ngày này. Vui lòng thử lại.");
      setDailyMenu(null);
      setNutritionData((prev) => ({
        calories: { ...prev.calories, current: 0 },
        protein: { ...prev.protein, current: 0 },
        carbs: { ...prev.carbs, current: 0 },
        fat: { ...prev.fat, current: 0 },
      }));
    } finally {
      setLoading(false);
    }
  }, [selectedDate, user, antdMessage]);

  useEffect(() => {
    if (user) {
      fetchData();
    }
  }, [fetchData, user]);

  const handleNavigateToFavorites = () => {
    navigate("/account/favorites");
  };

  const formatDateDisplay = (date) => {
    const today = new Date();
    const currentYear = today.getFullYear();

    const options = { weekday: "long", day: "numeric", month: "numeric" };
    if (date.getFullYear() !== currentYear) {
      options.year = "numeric";
    }

    if (date.toDateString() === today.toDateString()) {
      return `Hôm nay, ${date.toLocaleDateString("vi-VN", {
        day: "numeric",
        month: "numeric",
      })}`;
    }
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    if (date.toDateString() === yesterday.toDateString()) {
      return `Hôm qua, ${date.toLocaleDateString("vi-VN", {
        day: "numeric",
        month: "numeric",
      })}`;
    }
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    if (date.toDateString() === tomorrow.toDateString()) {
      return `Ngày mai, ${date.toLocaleDateString("vi-VN", {
        day: "numeric",
        month: "numeric",
      })}`;
    }
    return date.toLocaleDateString("vi-VN", options);
  };

  const handlePrevDay = () => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() - 1);
      return newDate;
    });
  };

  const handleNextDay = () => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + 1);
      return newDate;
    });
  };

  // SỬA ĐỔI: Hàm handleAddMeal với giới hạn số món
  const handleAddMeal = (mealType) => {
    const currentMealsInType = dailyMenu?.meals?.[mealType] || [];

    if (currentMealsInType.length >= 2) {
      antdMessage.warning(
        `Bạn không thể chọn quá 2 món ăn cho bữa ${mealTypeMapping[mealType]}.`
      );
      return;
    }

    setCurrentMealType(mealType);
    setIsModalOpen(true);
  };

  const handleToggleFavoriteMenu = useCallback(async () => {
    if (!dailyMenu || !dailyMenu._id) {
      antdMessage.error("Không tìm thấy ID thực đơn để đánh dấu yêu thích.");
      return;
    }

    if (!user) {
      setShowLoginModal(true);
      antdMessage.warning("Bạn cần đăng nhập để thực hiện chức năng này.");
      return;
    }

    try {
      const res = await api.put(`/daily/menu/${dailyMenu._id}/favorite`);
      const newIsFavoriteStatus = res.data.isFavorite;

      if (newIsFavoriteStatus) {
        antdMessage.success("Đã thêm thực đơn vào danh sách yêu thích.");
      } else {
        antdMessage.success("Đã bỏ thực đơn khỏi danh sách yêu thích.");
      }

      setDailyMenu((prevMenu) => ({
        ...prevMenu,
        isFavorite: newIsFavoriteStatus,
      }));
    } catch (err) {
      antdMessage.error(
        err.response?.data?.message ||
          "Lỗi khi thay đổi trạng thái yêu thích menu. Vui lòng thử lại."
      );
    }
  }, [dailyMenu, user, setShowLoginModal, setDailyMenu, antdMessage]);

  const handleRemoveMeal = useCallback(
    async (mealType, mealId) => {
      if (!dailyMenu) return;

      const actionKey = `remove-${mealId}`;
      setActionLoading((prev) => ({ ...prev, [actionKey]: true }));

      // Tạo bản sao meals và lọc món cần xóa
      const updatedMeals = { ...dailyMenu.meals };
      updatedMeals[mealType] = updatedMeals[mealType].filter(
        (meal) => meal._id?.toString() !== mealId
      );

      try {
        const response = await api.put("/daily/update", {
          dailyMenuId: dailyMenu._id,
          date: dailyMenu.date,
          meals: updatedMeals,
        });

        const updatedMenu = response.data;
        setDailyMenu(updatedMenu);

        setNutritionData((prev) => ({
          calories: {
            ...prev.calories,
            current: updatedMenu.totalCalories || 0,
          },
          protein: { ...prev.protein, current: updatedMenu.totalProtein || 0 },
          carbs: { ...prev.carbs, current: updatedMenu.totalCarbs || 0 },
          fat: { ...prev.fat, current: updatedMenu.totalFat || 0 },
        }));

        antdMessage.success("Đã xóa món ăn khỏi thực đơn!");
      } catch (err) {
        antdMessage.error(
          err.response?.data?.message ||
            "Không thể xóa món ăn khỏi thực đơn. Vui lòng thử lại."
        );
      } finally {
        setActionLoading((prev) => ({ ...prev, [actionKey]: false }));
      }
    },
    [dailyMenu, antdMessage]
  );

  const handleSaveRecipesToDailyMenu = useCallback(
    async (mealType, recipesToAdd) => {
      setLoading(true);
      setError(null);

      try {
        let currentMeals = {
          ...(dailyMenu?.meals || {
            breakfast: [],
            lunch: [],
            dinner: [],
            snack: [],
          }),
        };

        const updatedMealsMap = new Map();
        (currentMeals[mealType] || []).forEach((meal) => {
          if (meal && meal.recipe && meal.recipe._id) {
            updatedMealsMap.set(meal.recipe._id, { ...meal });
          } else {
          }
        });

        for (const newMealEntry of recipesToAdd) {
          const recipeId = newMealEntry.recipe._id;
          const quantityToAdd = newMealEntry.quantity;

          if (!recipeId) {
            continue;
          }

          if (updatedMealsMap.has(recipeId)) {
            const existingMeal = updatedMealsMap.get(recipeId);
            existingMeal.quantity += quantityToAdd;
            updatedMealsMap.set(recipeId, existingMeal);
          } else {
            updatedMealsMap.set(recipeId, {
              recipe: newMealEntry.recipe,
              quantity: quantityToAdd,
            });
          }
        }

        const finalMealListForType = Array.from(updatedMealsMap.values());
        const totalUniqueRecipesAfterUpdate = finalMealListForType.length;
        const totalQuantityAfterUpdate = finalMealListForType.reduce(
          (sum, meal) => sum + (meal?.quantity || 0),
          0
        );

        if (totalUniqueRecipesAfterUpdate > 2) {
          antdMessage.error(
            `Bữa ${mealTypeMapping[mealType]} không thể có quá 2 món ăn khác nhau. Vui lòng chọn lại.`
          );
          setLoading(false);
          setIsModalOpen(false);
          return;
        }

        if (totalQuantityAfterUpdate > 2) {
          antdMessage.error(
            `Tổng số phần ăn cho bữa ${mealTypeMapping[mealType]} không thể vượt quá 2. Vui lòng điều chỉnh số lượng.`
          );
          setLoading(false);
          setIsModalOpen(false);
          return;
        }

        currentMeals[mealType] = finalMealListForType;

        // Calculate total calories for warning
        let potentialTotalDailyCalories = 0;
        for (const type in currentMeals) {
          if (Array.isArray(currentMeals[type])) {
            potentialTotalDailyCalories += currentMeals[type].reduce(
              (subTotal, meal) => {
                if (
                  meal &&
                  meal.recipe &&
                  typeof meal.recipe.calories === "number" &&
                  typeof meal.quantity === "number"
                ) {
                  return subTotal + meal.recipe.calories * meal.quantity;
                }
                return subTotal;
              },
              0
            );
          }
        }

        const calorieGoal = user?.calorieGoal || 2000;
        if (potentialTotalDailyCalories > calorieGoal) {
          antdMessage.warning(
            `Tổng calo (${potentialTotalDailyCalories} kcal) vượt quá mục tiêu (${calorieGoal} kcal). Bạn vẫn có thể lưu thực đơn.`
          );
        }

        const mealsPayload = {};
        for (const type in currentMeals) {
          mealsPayload[type] = currentMeals[type]
            .map((meal) => {
              if (
                meal &&
                meal.recipe &&
                meal.recipe._id &&
                typeof meal.quantity === "number"
              ) {
                return {
                  recipe: meal.recipe._id,
                  quantity: meal.quantity,
                };
              }
              return null;
            })
            .filter(Boolean);
        }

        // Log payload for debugging

        let response;
        if (dailyMenu && dailyMenu._id) {
          response = await api.put("/daily/update", {
            dailyMenuId: dailyMenu._id,
            date: dailyMenu.date,
            meals: mealsPayload,
          });
          antdMessage.success("Thực đơn đã được cập nhật thành công!");
          if (response.data.calorieWarning) {
            antdMessage.warning(response.data.calorieWarning);
          }
        } else {
          const formattedDate = selectedDate.toISOString().split("T")[0];
          response = await api.post("/daily/create", {
            date: formattedDate,
            meals: mealsPayload,
          });
          antdMessage.success("Thực đơn đã được tạo thành công!");
          if (response.data.calorieWarning) {
            antdMessage.warning(response.data.calorieWarning);
          }
        }

        fetchData();
        setIsModalOpen(false);
      } catch (err) {
        setError("Không thể thêm/cập nhật món ăn. Vui lòng thử lại.");
        antdMessage.error("Không thể thêm/cập nhật món ăn. Vui lòng thử lại.");
        setIsModalOpen(false);
      } finally {
        setLoading(false);
      }
    },
    [dailyMenu, selectedDate, fetchData, antdMessage, user, mealTypeMapping]
  );

  // SỬA ĐỔI: Hàm renderMeals để hiển thị calo từng món và bỏ nút yêu thích món ăn
  const renderMeals = useCallback(
    (mealType) => {
      const meals = dailyMenu?.meals?.[mealType];

      if (!dailyMenu || !dailyMenu.meals || !Array.isArray(meals)) {
        return (
          <p style={{ textAlign: "center", color: "#666" }}>
            Chưa có món ăn nào cho bữa này.
          </p>
        );
      }

      return meals.length > 0 ? (
        meals.map((meal, index) => {
          const mealId = meal?._id || `temp-${index}`; // Sử dụng _id của meal
          const removeActionKey = `remove-${mealId}`;

          return (
            <MealCard key={mealId + index}>
              <Link to={`/recipes/${meal?.recipe?.slug}`}>
                <MealInfo>
                  <img
                    src={
                      meal?.recipe?.imageUrl || "https://via.placeholder.com/60"
                    }
                    alt={meal?.recipe?.name || "Unknown Dish"}
                  />
                  <div>
                    <h3>{meal?.recipe?.name || "Unnamed Dish"}</h3>
                    <span>
                      {meal?.quantity || 0} phần (
                      {Math.round(
                        (meal?.recipe?.calories || 0) * (meal?.quantity || 0)
                      )}{" "}
                      kcal)
                    </span>
                  </div>
                </MealInfo>
              </Link>
              <MealActions>
                <ActionButton
                  onClick={() => handleRemoveMeal(mealType, mealId)}
                  title="Xóa khỏi thực đơn"
                  loading={actionLoading[removeActionKey]}
                >
                  ✕
                </ActionButton>
              </MealActions>
            </MealCard>
          );
        })
      ) : (
        <p style={{ textAlign: "center", color: "#666" }}>
          Chưa có món ăn nào cho bữa này.
        </p>
      );
    },
    [dailyMenu, actionLoading, handleRemoveMeal]
  );

  const handleDateSelect = (date) => {
    if (date) {
      setSelectedDate(date.toDate());
    }
    setIsCalendarVisible(false);
  };

  return (
    <DailyMenuPageWrapper>
      <SideNavAccount />
      <MainContent>
        <Header>
          <DateNavigation>
            <ArrowButton onClick={handlePrevDay}>
              <IoIosArrowBack />
            </ArrowButton>
            <h2>{formatDateDisplay(selectedDate)}</h2>
            <ArrowButton onClick={handleNextDay}>
              <IoIosArrowForward />
            </ArrowButton>
            <CalendarWrapper>
              <CalendarButton onClick={() => setIsCalendarVisible(true)}>
                <BsCalendar3 />
              </CalendarButton>
              <DatePicker
                open={isCalendarVisible}
                value={dayjs(selectedDate)}
                onChange={handleDateSelect}
                onOpenChange={(open) => setIsCalendarVisible(open)}
                allowClear={false}
                inputRender={() => null}
              />
            </CalendarWrapper>
          </DateNavigation>

          <HeaderActions>
            {dailyMenu && (
              <FavoriteMenuButton onClick={handleToggleFavoriteMenu}>
                {dailyMenu.isFavorite ? (
                  <AiFillHeart size={24} color="red" />
                ) : (
                  <AiOutlineHeart size={24} />
                )}
                {dailyMenu.isFavorite ? "Đã yêu thích" : "Yêu thích menu"}
              </FavoriteMenuButton>
            )}

            <FavoritesButton onClick={handleNavigateToFavorites}>
              <AiOutlineHeart className="heart-icon" />
              Món yêu thích
            </FavoritesButton>
          </HeaderActions>
        </Header>

        {loading ? (
          <p>Đang tải thực đơn...</p>
        ) : error ? (
          <p style={{ color: "red" }}>{error}</p>
        ) : (
          <>
            <NutritionSummary>
              {Object.keys(nutritionData).map((key) => {
                const item = nutritionData[key];
                const progress = (item.current / item.target) * 100 || 0;
                return (
                  <NutritionItem key={key}>
                    <h4>{key.charAt(0).toUpperCase() + key.slice(1)}</h4>
                    <ProgressBar progress={progress > 100 ? 100 : progress} />
                    <p>
                      {Math.round(item.current)} {item.unit} / {item.target}{" "}
                      {item.unit}
                    </p>
                  </NutritionItem>
                );
              })}
            </NutritionSummary>

            <MealsList>
              <MealSection>
                <MealHeader>
                  <h2>
                    Bữa sáng ({Math.round(calculateMealCalories("breakfast"))}{" "}
                    kcal)
                  </h2>
                  <AddButton onClick={() => handleAddMeal("breakfast")}>
                    <AiOutlinePlus /> Thêm
                  </AddButton>
                </MealHeader>
                {renderMeals("breakfast")}
              </MealSection>

              <MealSection>
                <MealHeader>
                  <h2>
                    Bữa trưa ({Math.round(calculateMealCalories("lunch"))} kcal)
                  </h2>
                  <AddButton onClick={() => handleAddMeal("lunch")}>
                    <AiOutlinePlus /> Thêm
                  </AddButton>
                </MealHeader>
                {renderMeals("lunch")}
              </MealSection>

              <MealSection>
                <MealHeader>
                  <h2>
                    Bữa tối ({Math.round(calculateMealCalories("dinner"))} kcal)
                  </h2>
                  <AddButton onClick={() => handleAddMeal("dinner")}>
                    <AiOutlinePlus /> Thêm
                  </AddButton>
                </MealHeader>
                {renderMeals("dinner")}
              </MealSection>

              <MealSection>
                <MealHeader>
                  <h2>
                    Bữa ăn vặt ({Math.round(calculateMealCalories("snack"))}{" "}
                    kcal)
                  </h2>
                  <AddButton onClick={() => handleAddMeal("snack")}>
                    <AiOutlinePlus /> Thêm
                  </AddButton>
                </MealHeader>
                {renderMeals("snack")}
              </MealSection>
            </MealsList>
          </>
        )}
      </MainContent>
      {isModalOpen && (
        <AddRecipeModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onAddRecipe={handleSaveRecipesToDailyMenu}
          mealType={currentMealType}
        />
      )}
    </DailyMenuPageWrapper>
  );
};

export default DailyMenuPage;
